import React, { useState } from "react";
import { FaAndroid, FaAppStore, FaAppStoreIos } from "react-icons/fa";
import { Link } from "react-router-dom";

const NavItemWithSubmenu = ({ showSubmenu, setShowSubmenu }) => {
  // const [showSubmenu, setShowSubmenu] = useState(false);
// console.log('showSubmenu', showSubmenu)
  return (
    <>
    
    <li
      className="nav-item position-relative pointer"
      // onMouseEnter={() => setShowSubmenu(true)}
      // onMouseLeave={() => setShowSubmenu(false)}
      onClick={() => setShowSubmenu(!showSubmenu)}
    >
      <span  className=" fw-600 text-white  cus_mr_20 nav-link get_app_header_text">
        Get the App
      </span>

      {showSubmenu && (
        <ul
          className="position-absolute text-dark list-unstyled mt-3   rounded "
          style={{ top: "100%", left: 0, zIndex: 1000, display: 'flex', flexDirection: 'column' }}
        >
          <Link className="dropdown-item" target="_blank" rel="noopener noreferrer" to="https://www.lionsdengames.net/download-ios" >
            <li className="get_app_header">
              <FaAppStore className="get_app_header_logo" /> IOS
            </li>
          </Link>
          <Link className="dropdown-item" target="_blank" rel="noopener noreferrer" to="https://www.lionsdengames.net/download-android">
            <li className="get_app_header">
              <FaAndroid className="get_app_header_logo" /> Android
            </li>
          </Link>
        </ul>
      )}
    </li>
    </>
  );
};
export default NavItemWithSubmenu;
